// extracted by mini-css-extract-plugin
export default {"header":"Header_header__rPDv8","logo":"Header_logo__ZDH5n"};